export default __webpack_public_path__ + "static/media/VU.8f757fce.svg";